import { Button, ButtonProps, CircularProgress } from "@material-ui/core";

export default function SubmitButton({
  isSubmitting = false,
  disabled = false,
  submitText = "Submit",
  loadingText = submitText,
  ...props
}: {
  isSubmitting?: boolean;
  disabled?: boolean;
  submitText?: string;
  loadingText?: string;
} & ButtonProps): JSX.Element {
  return (
    <Button
      type="submit"
      variant="contained"
      color="primary"
      disabled={isSubmitting || disabled}
      {...props}
    >
      {isSubmitting && (
        <CircularProgress size={20} style={{ marginRight: "12px" }} />
      )}
      {isSubmitting ? loadingText : submitText}
    </Button>
  );
}
